'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lruMemoize = require('lru-memoize');

var _lruMemoize2 = _interopRequireDefault(_lruMemoize);

var _validation = require('utils/validation');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var surveyValidation = (0, _validation.createValidator)({
  // q: [required],
  occupation: (0, _validation.maxLength)(20) // single rules don't have to be in an array
});
exports.default = (0, _lruMemoize2.default)(10)(surveyValidation);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Knowledge/surveyValidation.js
// module id = 1507
// module chunks = 0